"use client";

import { Link, type TAuthContextType, useAuth } from "@/components";
import Image from "next/image";
import myAnalogLogo from "/public/assets/logo/logo-myAnalog.svg";
import { LOGIN_URL } from "@/lib/constants/auth.constants";
import { t } from "@/utils";

export default function FooterUser() {
	const { isAuthenticated }: TAuthContextType = useAuth();

	return (
		<>
			<Link
				isSameTab
				href="https://my.analog.com/en/app/"
				className="mr-6"
				data-testid="footer-my-analog-img-link"
			>
				<Image
					src={myAnalogLogo}
					alt="myAnalog"
					data-testid="footer-my-analog-img"
				/>
			</Link>
			{isAuthenticated && (
				<Link
					isSameTab
					href="https://my.analog.com/en/app/"
					className="hmc-link-xs"
					data-testid="footer-my-analog-text-not-auth-link"
				>
					{t("auth.your-account")}
				</Link>
			)}

			{!isAuthenticated && (
				<a
					href={LOGIN_URL}
					className="hmc-link-xs"
					data-testid="footer-my-analog-text-auth-link"
					target="_self"
				>
					{t("auth.login-signup")}
				</a>
			)}
		</>
	);
}
